/**
 * Where the "Demo starten" call to action sends a visitor (#629, moved by #917 and #1856).
 *
 * Since #1856 the landing offers one demo: the static, self-running journey the edge serves at
 * /demo/ on this host. It needs no sign-up, session or backend and runs on fictional data, so
 * the click is a plain navigation and the story starts on arrival.
 */
export const DEMO_URL = "/demo/";
